module.exports = __webpack_public_path__ + "img/compass.35df2b20.svg";